module.exports = __webpack_public_path__ + "static/discovery-3e5da13db3d5623a35a545d0dc8670d9.png";